import type { FunctionComponent, PropsWithChildren } from 'react'

import styles from './video-content.module.scss'
import { asVideoType } from '@app-types/video'
import { Video } from '@components/video'
import type { VideoFragment } from '@graphql/fragments/SectionOfThumbnailsFragment.graphql'

export const VideoContent: FunctionComponent<PropsWithChildren<Props>> = (
    props,
) => {
    const videoProps = asVideoType(props)

    if (!videoProps) {
        return null
    }

    return (
        <div className={styles['video-content']}>
            <Video {...videoProps} />
        </div>
    )
}

type Props = VideoFragment
